import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboEixoComponent} from './combo-eixo.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboEixoComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboEixoComponent]
})
export class ComboEixoModule {
}
